
 
<mat-form-field>
    <input matInput (change)="applyFilter($event)" placeholder="Filter">
</mat-form-field>
<!-- <a class="btn btn-primary" href="https://nimionlineadmission.in/dgt/downloaddatadirnimixls.php">Download</a> -->


<div class="example-container mat-elevation-z8">
    <mat-table #table [dataSource]="dataSource" matSort>

        <!--- Note that these columns can be defined in any order.
            The actual rendered columns are set as a property on the row definition" -->

            <ng-container matColumnDef="ticketId">
                <mat-header-cell *matHeaderCellDef mat-sort-header> # </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index;"> {{paginator.pageSize * paginator.pageIndex + i+1}}   </mat-cell>
            </ng-container>

   
        <!-- Symbol Column -->
        <ng-container matColumnDef="iticode">
            <mat-header-cell *matHeaderCellDef mat-sort-header> iti code </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.iticode}} </mat-cell>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="singlerollno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> name
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.itiname}} </mat-cell>
        </ng-container>


        <!-- Weight Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> distict </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.distict}} </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="mobileno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> key </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <!-- <img style="width: 20px;" src="http://localhost:5001/{{element.upload}}">   -->
              {{element.statekey}}
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="ccrefno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> state </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.state}} </mat-cell>
        </ng-container>

       

       

   

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    </mat-table>
    
    <mat-paginator [length]="totallength" (page)="pageEvent = $event; pageChanged($event)" [pageSizeOptions]="[ 5,10, 25, 50, 100, 500]"></mat-paginator>



</div>

<!-- <hr>

<h2>Direct NIMI Payment Related Issue Resolved and Rejected List</h2>

<mat-form-field>
    <input matInput (keyup)="applyFilterView($event)" placeholder="Filter">
</mat-form-field>


<div class="example-container mat-elevation-z8">
    <mat-table [dataSource]="dataSource_view" #t1Sort="matSort" matSort>

        <ng-container matColumnDef="ticketId">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Ticket Id </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ticketId}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="iticode">
            <mat-header-cell *matHeaderCellDef mat-sort-header> State </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.state}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="singlerollno">
            <mat-header-cell *matHeaderCellDef mat-sort-header>  Payment Method  </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.paymethod}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header>  UTR / Transcation Number  </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.utr}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="mobileno">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Upload </mat-header-cell>
            <mat-cell *matCellDef="let element">
               <img style="width: 20px;" src="https://grsnodetest.nimiquestionbank.in/{{element.upload}}">
              </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ccrefno">
            <mat-header-cell *matHeaderCellDef mat-sort-header>  Associated Mobile Number  </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.ascmob}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ccrefnostatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header>  Payment / Transction Date  </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.date}} </mat-cell>
        </ng-container>

                <ng-container matColumnDef="entrydate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Grievance Date </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.entrydate}} </mat-cell>
                </ng-container>


        <ng-container matColumnDef="admin_status">
            <mat-header-cell *matHeaderCellDef mat-sort-header> status
            </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.admin_status}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Action </mat-header-cell>
            <mat-cell *matCellDef="let row"> <button class="btn btn-success" (click)="selected_view.select(row)"
                    (click)="report_view()">View</button>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns_view"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns_view;"></mat-row>

    </mat-table>
    <mat-paginator #t1Paginator="matPaginator" [pageSizeOptions]="[3, 10, 25, 100]"></mat-paginator>


</div> -->
